import loadable from '@loadable/component';
import {
  ACTION_TYPE,
  COMPONENT_NAME,
} from '@skyscanner-internal/landing-pages-shared-constants/constants';
import logger from 'saddlebag-logger';

import logMiniEventHelper from '../../mini-event/logMiniEventHelper';
import withErrorBoundary from '../ErrorBoundary';

import type { SearchControlsProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/CarHireSearchControlsProps';

const IntersectionObserverWrapper = loadable(
  () => import('../IntersectionObserverWrapper/IntersectionObserverWrapper'),
);

const SearchControlsGC = loadable(
  () =>
    import('@skyscanner-internal/global-components/car-hire-search-controls'),
);

const SearchControls = (props: SearchControlsProps) => {
  const {
    autosuggestExpVal,
    autosuggestUrl,
    cldr,
    culture,
    dropOffDateTime,
    dropOffLocation,
    enableCombinedCalendar,
    enableDropOffLocation,
    filtersQueryParam,
    initialSearchMode,
    isAboveMobile,
    isProductionEnv,
    isV2Enabled,
    pickUpDateTime,
    pickUpLocation,
    resultsPath,
    roadTripSearchControlVariant,
    trackingProps,
    translations,
  } = props;

  return (
    <SearchControlsGC
      logger={logger}
      culture={culture}
      strings={translations}
      cldr={cldr}
      resultsPath={resultsPath}
      trackingProps={trackingProps}
      autosuggestUrl={autosuggestUrl}
      autosuggestExpVal={autosuggestExpVal}
      pickUpLocation={pickUpLocation}
      pickUpDateTime={pickUpDateTime}
      dropOffLocation={dropOffLocation}
      dropOffDateTime={dropOffDateTime}
      filtersQueryParam={filtersQueryParam}
      isProductionEnv={isProductionEnv}
      enableDropOffLocation={enableDropOffLocation}
      enableCombinedCalendar={enableCombinedCalendar}
      initialSearchMode={initialSearchMode}
      unstable__isV2Enabled={isV2Enabled}
      isAboveMobile={isAboveMobile}
      // Only car hire home needs search summary, so this is hardcoded to false
      isSearchSummaryNeeded={false}
      roadTripSearchControlVariant={roadTripSearchControlVariant}
    />
  );
};

const searchControlsWrapper = (props: SearchControlsProps) => (
  <IntersectionObserverWrapper
    onElementSeen={() =>
      logMiniEventHelper({
        action_type: ACTION_TYPE.COMPONENT_VISIBLE,
        component_name: COMPONENT_NAME.CAR_HIRE_SEARCH_CONTROLS,
      })
    }
  >
    <SearchControls {...props} />
  </IntersectionObserverWrapper>
);

const SearchControlsWithErrorBoundary = withErrorBoundary(
  searchControlsWrapper,
  'car-hire-search-controls-component',
);

export default SearchControlsWithErrorBoundary;
